export let passiveSupported = false;

try {
    const options: AddEventListenerOptions = Object.defineProperty(
        {},
        'passive',
        {
            get(): boolean {
                passiveSupported = true;
                return true;
            },
        }
    );

    window.addEventListener('test', () => {}, options);
} catch (err) {
    console.error(err);
}
